import React from "react";
import RecapView from "../components/RecapView";

export default function DailyRecap() {
  return (
    <RecapView
      apiBase="/sales-recap"
      title="Rangkuman Penjualan Harian"
      subtitle="Daftar dari data kasiran (tanggal kasir); detail nett/voucher/fee dari Desty + HPP & perkiraan profit"
      exportPrefix="rangkuman"
    />
  );
}
